import Tabs from "./Base/Tabs";
import Toggle from "./Toggle";
import TabContext from "./Base/TabContext";
export default Tabs;
export { Tabs, Toggle, TabContext };
